import React from "react";

import { IconButton } from "@mui/material";
import { DefaultTooltip } from "Components/Generic/Tooltip";
import { Add as IconAdd } from "iconsax-react";
import { Fleet } from "Models/fleet";
import { Member } from "Models/members/member";
import { Team } from "Models/team";
import { useTranslation } from "react-i18next";

import { ResourceTeamEquipmentsCard } from "../ResourceTeamEquipmentsCard";
import { ResourceTeamLeaderCard } from "../ResourceTeamLeaderCard";
import { ResourceTeamMembersCard } from "../ResourceTeamMembersCard";
import { Header, TeamInfosContainer, TeamsInfos, TeamsInfosWrapper, Title } from "./styles";

interface ResourceTeamCardProps {
  name: string;
  teamLeader?: Member | null;
  members?: Member[] | null;
  equipments?: Fleet[] | null;

  team: Team;
  hasAddTeamToBoardButton?: boolean;
  onAddTeamToBoard?: (param: Team) => void;
}

export const ResourceTeamCard: React.FC<ResourceTeamCardProps> = ({
  name,
  teamLeader,
  equipments,
  members,
  team,
  hasAddTeamToBoardButton,
  onAddTeamToBoard,
}) => {
  const { t: translate } = useTranslation();

  const filtredMembers = members?.filter((member) => member.id !== teamLeader?.id) ?? [];

  return (
    <TeamInfosContainer>
      <Header>
        <Title>{name}</Title>

        {hasAddTeamToBoardButton && (
          <DefaultTooltip placement="top" title={translate("addTeamToBoard")}>
            <IconButton onClick={() => onAddTeamToBoard?.(team)}>
              <IconAdd size={20} />
            </IconButton>
          </DefaultTooltip>
        )}
      </Header>
      <TeamsInfosWrapper>
        <TeamsInfos>
          <ResourceTeamLeaderCard teamLeader={teamLeader} />
        </TeamsInfos>

        <TeamsInfos>
          <ResourceTeamMembersCard members={filtredMembers} />
        </TeamsInfos>

        <TeamsInfos>
          <ResourceTeamEquipmentsCard equipments={equipments || []} />
        </TeamsInfos>
      </TeamsInfosWrapper>
    </TeamInfosContainer>
  );
};
